import { FC } from 'react';
import { Button, Heading, Text } from '@chakra-ui/react';
import { useTransactions } from 'store/transactions/useTransactions';
import { ethers } from 'ethers';

type Props = {
  contractAddress: string;
  aludelAddress: string;
  aludelAbi: ethers.ContractInterface;
};

export const RenounceOwnershipForm: FC<Props> = ({
  contractAddress,
  aludelAddress,
  aludelAbi
}) => {
  const { renounceOwnership } = useTransactions();

  const renounce = async () => {
    await renounceOwnership(contractAddress, aludelAddress, aludelAbi);
  };

  return (
    <>
      <Heading size='md' mb={6}>
        Renounce Ownership
      </Heading>
      <Text color='gray.200' mb={6}>
        This option will remove your ownership from the contract and it can no
        longer be owned or reclaimed. This means any functions that rely on an
        owner being set will no longer be operational.
      </Text>
      <Button
        px={6}
        type='submit'
        borderRadius={'lg'}
        onClick={() => renounce()}
      >
        Renounce Ownership
      </Button>
    </>
  );
};
